export default __webpack_public_path__ + "static/media/legion.166224a7.png";